import { Component } from "react";
import InputGroup from "react-bootstrap/InputGroup"
import DropdownButton from "react-bootstrap/DropdownButton"
import Form from "react-bootstrap/Form"
import Dropdown from "react-bootstrap/Dropdown"
import {connect} from "react-redux"
import * as dashboardSearchActions from 'member/redux/modules/dashboardSearch'
import { components } from 'react-select'
import ListGroup from "react-bootstrap/ListGroup"
import {Image} from "react-bootstrap"
import DebounceAsync from "../DebounceAsync"
import environmentVariables from "shared/enviromentVariables/index.js.erb"

const searchItems = [
  { key: 'all', title: 'All' },
  { key: 'search_items', title: 'All Current' },
  { key: 'directors', title: 'Directors' },
  { key: 'executives', title: 'Executives' },
  { key: 'previous_directors_and_executives', title: 'Previous Directors/Execs' },
  { key: 'potential_directors', title: `${environmentVariables.app_name} subscribers` },
  { key: 'companies', title: 'Companies' },
  { key: 'private_companies', title: 'Private Companies' },
  { key: 'superannuations', title: 'Superannuation' },
  { key: 'governments', title: 'Government' },
  { key: 'other_governments', title: 'Other Government' },
  { key: 'not_for_profits', title: 'Not for Profits' },
]

const search = (props, searchFor, searchText, callback) => {
  if(searchText.length <= 2){
    return callback(false)
  }
  const {
    loading,
    searchData
  } = props

  if (!loading) {
    searchData({type: searchFor, query: searchText}, callback)
  }
}

const Control = ({ children, ...props }) => {
  return (
    <components.Control {...props}>
      {children}
    </components.Control>
  );
}

const MenuList = props => {
  const children = props.children,
    className = props.className,
    cx = props.cx,
    getStyles = props.getStyles,
    innerProps = props.innerProps,
    innerRef = props.innerRef,
    isMulti = props.isMulti;
  return (
    <ListGroup variant="flush" ref={innerRef} {...innerProps}
               className={cx({
                 'menu-list': true,
                 'menu-list--is-multi': isMulti
               }, className)}
               style={getStyles('menuList', props)}>
      {children}
    </ListGroup>
  );
}

const Option = props => {
  const children = props.children,
    className = props.className,
    cx = props.cx,
    getStyles = props.getStyles,
    isDisabled = props.isDisabled,
    isFocused = props.isFocused,
    isSelected = props.isSelected,
    innerRef = props.innerRef,
    innerProps = props.innerProps,
    image = props.data.image,
    subTitle = props.data.subTitle;
  return (
    <ListGroup.Item ref={innerRef} {...innerProps}
                    className={cx({
                      option: true,
                      'option--is-disabled': isDisabled,
                      'option--is-focused': isFocused,
                      'option--is-selected': isSelected
                    }, className)}
                    style={getStyles('option', props)}>
      <div className="d-flex flex-row">
        <div>
          <Image src={image} style={{maxHeight: '50px', maxWidth: '50px', height: 'auto', width: 'auto'}}/>
        </div>
        <div className="d-flex flex-column justify-content-start ml-2">
          <div>
            {children}
          </div>
          <div style={{color: 'green'}}>
            ({subTitle})
          </div>
        </div>
      </div>
    </ListGroup.Item>
  );
}

class DashboardSearch extends Component {
  constructor(props) {
    super(props);

    this.state = { searchFor: 'all' }
  }

  _renderSearchItems = () => {
    return searchItems.map(({ key, title }) => <Dropdown.Item href="" key={key} searchfor={key} onClick={this._handleClick}>{title}</Dropdown.Item>)
  }

  _filterValues = () => {
    return(
      this.props.result.map((result, index) => {
        const { id, name, sub_title, image, path } = result
        return(
          {
            id: id,
            value: `${index}-${id}`,
            label: name,
            subTitle: sub_title,
            image: image,
            path: `#/${path}/${id}`
          }
        )
      })
    )
  }

  _handleChange = (inputValue, resolve, reject) => {
    const { searchFor } = this.state

    search(this.props, searchFor, inputValue, (success) => {
      if(success)
        resolve(this._filterValues())
      else
        reject("Something went wrong. Please try again later.")
    })
  }

  _handleResultClick = (object) => {
    if (this.props.forProfile == true) {
      this.props.setDirector(object)
    } else {
      if(object)
        window.location = object.path
    }
  }

  _formSubmit = (event) => {
    event.preventDefault()
    event.stopPropagation()

    const form = event.target

    if(form.checkValidity() === false) {
      form.classList.add('was-validated');
    }else{
      const { searchFor } = this.state
      search(this.props, searchFor, '')
    }
  }

  _handleClick = (evt) => {
    evt.preventDefault()

    const value = evt.currentTarget.attributes.searchfor.value

    this.setState({
      searchFor: value
    })
  }

  render() {
    const { searchFor } = this.state

    const customStyles = {
      container: (provided, state) => ({
        ...provided,
        width: '250px'
      }),
      option: (provided, state) => ({
        ...provided,
        cursor: "pointer"
      }),
      menu: (provided, state) => ({
        ...provided,
        width: '250px'
      }),
      control: (provided, state) => ({
        ...provided,
        borderRadius: 0
      })
    }

    return(
      <Form inline style={{ width: '100%' }} onSubmit={this._formSubmit} noValidate="novalidate" autoComplete="off">
        <div className="autocomplete" style={{ width: '100%' }}>
          <InputGroup>
            <InputGroup.Prepend>
              <Dropdown>
                <Dropdown.Toggle variant="primary" id="search-dropdown" style={{borderRadius: 0, minWidth: '100px'}}>
                  {searchItems.find(item => item.key === searchFor).title}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  {this._renderSearchItems()}
                </Dropdown.Menu>
              </Dropdown>
            </InputGroup.Prepend>
            <DebounceAsync
              loadOptions={this._handleChange}
              onChange={(value) => this._handleResultClick(value)}
              components={{ DropdownIndicator:() => null, IndicatorSeparator:() => null, Option, MenuList, Control }}
              results={this.props.result}
              styles={customStyles}
            />
          </InputGroup>
        </div>
      </Form>
    )
  }
}

function mapStateToProps(state) {
  const { dashboardSearch } = state;

  const {
    loading,
    loaded,
    result
  } = dashboardSearch

  return {
    loading,
    loaded,
    result
  }
}

const mapDispatchToProps = {
  searchData: dashboardSearchActions.search
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardSearch)
